import walletTokenBalancesAtom from '../wallet/walletTokenBalancesAtom';
import nostraTokenBalancesAtom from './nostraTokenBalanceAtom';

/**
 * Atoms whose refresh should be paused during lend-and-borrow transactions.
 *
 * Without pausing, the 30-second polling cycle on these atoms can pick up on-chain balance
 * changes (e.g. wallet balance deducted) before the transaction receipt is confirmed,
 * causing the UI to briefly show inconsistent state (e.g. "insufficient balance" error
 * while a deposit is still pending).
 *
 * By pausing refreshes for the duration of a transaction, balance and transaction status
 * always update atomically — the balance only refreshes once the transaction completes.
 */
const balanceAtoms = [walletTokenBalancesAtom, nostraTokenBalancesAtom];

/**
 * Pause all balance atom refreshes. Call before starting a transaction.
 * Must be paired with a resumeBalanceRefresh() call (use try/finally).
 */
export function pauseBalanceRefresh() {
  balanceAtoms.forEach(atom => atom.pauseRefresh());
}

/**
 * Resume all balance atom refreshes. Call when a transaction completes (success or failure).
 * If any refreshes were deferred while paused, they execute automatically.
 */
export function resumeBalanceRefresh() {
  balanceAtoms.forEach(atom => atom.resumeRefresh());
}
